import api from './api'
import type { PathSegment } from '../types'

export const pathApi = {
  getSegments: (siteId: string) => api.get<PathSegment[]>(`/sites/${siteId}/path-segments`).then((r) => r.data),
  createSegment: (siteId: string, data: Partial<PathSegment>) => api.post<PathSegment>(`/sites/${siteId}/path-segments`, data).then((r) => r.data),
  updateSegment: (siteId: string, id: string, data: Partial<PathSegment>) => api.patch<PathSegment>(`/sites/${siteId}/path-segments/${id}`, data).then((r) => r.data),
  deleteSegment: (siteId: string, id: string) => api.delete(`/sites/${siteId}/path-segments/${id}`),
}
